export const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME;

export const ENDPOINTS = {
  fetchContentSearchResults: "/resource/search",
  getResource: "/resource"
} as const;
